import styled, { css } from 'styled-components';

import ArrowLink from 'Elements/Link/Arrow';

import { StyledSideBox as HeroBannerEventModule } from 'Modules/HeroBanner/MakeWaves/Event/Event.styled';

export const Wrapper = styled.div`
    ${({ theme }) => css`
        padding: 0.75rem;
        background: ${theme.colors.tertiary.hex};
        color: ${theme.colors.primaryContrast.hex};
        border-radius: 0.5rem;
        text-align: center;
        position: relative;
        z-index: 1;

        ${HeroBannerEventModule} & {
            padding: 0.5rem 1rem 1rem;
        }

        @media ${theme.breakpoints.medium.media} {
            padding: 1rem;
        }

        @media ${theme.breakpoints.large.media} {
            padding: 2rem 1rem;
        }
    `}
`;

export const Heading = styled.h2`
    ${({ theme }) => css`
        font-family: ${theme.fonts.secondary};
        font-size: 2.6rem;
        line-height: 0.6;
        font-weight: 300;
        color: ${theme.colors.accents[3].hex};
        margin: 0.75rem 0 0;

        ${HeroBannerEventModule} & {
            font-size: 2.25rem;
            line-height: 1;
        }

        @media ${theme.breakpoints.medium.media} {
            font-size: 3.75rem;
        }
    `}
`;

export const Subheading = styled.span`
    ${({ theme }) => css`
        font-family: ${theme.fonts.secondary};
        font-size: 1.6rem;
        line-height: 0.875;
        color: ${theme.colors.accents[3].hex};

        @media ${theme.breakpoints.medium.media} {
            font-size: 2.25rem;
        }
    `}
`;

export const Information = styled.p`
    ${({ theme }) => css`
        margin: 1rem auto 1.5rem;
        font-size: 1.125rem;

        ${HeroBannerEventModule} & {
            margin: 0.5rem auto 0.5rem;
            max-width: 80%;
        }

        @media ${theme.breakpoints.medium.media} {
            font-size: 1.25rem;
            max-width: 60rem;
        }
    `}
`;

export const StyledLink = styled(ArrowLink)`
    ${({ theme }) => css`
        font-size: 1.125rem;
        line-height: 1.25;
        font-weight: 700;

        @media ${theme.breakpoints.large.media} {
            font-size: 1.5rem;
        }
    `}
`;
